import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ApiError from '../../../components/error/ApiError';
import DeprecatedError from '../../../components/error/DeprecatedError';
import { EmbeddedVideo } from '../../video/components/EmbeddedVideo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OVERVIEW_MAX_CONTENT_WIDTH = 1180;
export const OverviewContent = ({
  backgroundColor,
  deprecated,
  deprecationCta,
  loading,
  error,
  fallbackThumbnailUrl,
  children,
  headerIcons,
  lessonId,
  trackId,
  shortId,
  assetLanguage,
  onVideoProgress,
  autoplay = true,
  isInternalContent = false,
  ribbonText: ribbonTextProp,
  ribbonUse: ribbonUseProp
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const ribbonText = isInternalContent ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.internal"
  }) : ribbonTextProp;
  const ribbonUse = isInternalContent ? 'norman' : ribbonUseProp;
  return /*#__PURE__*/_jsx(Flex, {
    alignSelf: loading ? 'center' : 'normal',
    backgroundColor: backgroundColor,
    flexDirection: "column",
    maxInlineSize: "100%",
    minBlockSize: "100%",
    position: "relative",
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      flex: 1,
      grow: true,
      maxBlockSize: "660px",
      maxInlineSize: "100%",
      size: "medium"
    }) : deprecated ? /*#__PURE__*/_jsx(View, {
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(DeprecatedError, {
        deprecationCta: deprecationCta
      })
    }) : error ? /*#__PURE__*/_jsx(View, {
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: error.networkError,
        marker404: "OVERVIEW_MODAL_API_404",
        markerDefault: "OVERVIEW_MODAL_API_ERROR",
        showLink: false
      })
    }) : /*#__PURE__*/_jsx(NavMarker, {
      name: "OVERVIEW_MODAL_LOADED",
      children: /*#__PURE__*/_jsxs(View, {
        position: "relative",
        children: [ribbonText && /*#__PURE__*/_jsx(Ribbon, {
          position: "left",
          use: ribbonUse,
          zIndex: "11",
          children: ribbonText
        }), /*#__PURE__*/_jsxs(View, {
          "data-test-id": "overview-modal-content",
          marginBlock: "0",
          maxInlineSize: "100%",
          overflowX: "hidden",
          position: "relative",
          children: [/*#__PURE__*/_jsx(EmbeddedVideo, {
            autoPlay: autoplay,
            fallbackThumbnailUrl: fallbackThumbnailUrl,
            language: assetLanguage,
            lessonId: lessonId,
            mutedByDefault: true,
            onPlay: onVideoProgress,
            renderContext: "academy",
            shortId: shortId,
            subtitleLanguage: assetLanguage.toLowerCase(),
            trackId: trackId
          }), /*#__PURE__*/_jsx(View, {
            insetBlockStart: "24px",
            insetInlineEnd: isMobile ? '68px' : '26px',
            position: "absolute",
            children: headerIcons
          }), children]
        })]
      })
    })
  });
};
export default OverviewContent;